<router-outlet></router-outlet>

<!--
  Global loading overlay.

  disableAnimation is set on purpose (do not remove it):
  ngx-spinner removes this overlay with Angular's class based `animate.leave` ("fade-out").
  That mechanism releases the DOM node only when the CSS transition really ends
  (transitionend). When a show/hide pair happens inside the same animation frame
  (very common: ngx-spinner uses 10ms timers for both show() and hide()), the
  opacity transition never runs, no transitionend is fired and the overlay node is
  never removed. It then stays forever in the DOM as an invisible, position: fixed,
  full screen element that swallows every click - the page looks "dead" until it is
  reloaded several times.
  With disableAnimation the overlay is added and removed synchronously, so no leftover
  element can ever block the UI.

  The visible design is the custom content below (see the `.app-loader*` styles in
  src/styles.scss): a frosted glass card with a dual spinning ring, an indeterminate
  progress bar and a caption.
-->
<ngx-spinner bdColor="rgba(15, 23, 42, 0.78)" size="medium" [disableAnimation]="true">
  <div class="app-loader" role="status" aria-live="polite" aria-label="Loading">
    <div class="app-loader__card">
      <div class="app-loader__rings">
        <span class="app-loader__ring app-loader__ring--outer"></span>
        <span class="app-loader__ring app-loader__ring--inner"></span>
        <span class="app-loader__dot"></span>
      </div>
      <div class="app-loader__bar"><span></span></div>
      <p class="app-loader__text">Please wait</p>
    </div>
  </div>
</ngx-spinner>
